module.exports = __webpack_public_path__ + "img/sinistreKiray.232e7bb2.png";